<template>
  <div class="ds-manager__component general">
    <div class="ds-manager__component-title">
      <r-title type="title-2">{{ $t("ds-manager:general:title") }}</r-title>
    </div>
    <div class="ds-manager__component-content">
      <div class="ds-manager__component-subtitle">
        <r-text type="caption">
          {{ $t("ds-manager:general:subtitle") }} ({{ dsLength }})
        </r-text>
      </div>
      <ds-tree
        module="dsManagerTree"
        show-tools
        bordered
        :node-click-handler="openDsEditor"
      />
    </div>
  </div>
</template>

<script>
import dsTree from "@/components/ds-tree/ds-tree.vue";

export default {
  props: { menuClickHandler: { type: Function } },
  components: {
    dsTree
  },
  computed: {
    dsLength() {
      return this.$store.state.dsTreeState.dsTree.length;
    }
  },
  methods: {
    openDsEditor(_, object) {
      this.$store.commit("SET_DS_MANAGER_ACTIVE_DS", object);
      this.menuClickHandler("ds-manager-editor");
    }
  }
};
</script>

<style lang="scss">
.ds-manager__component {
  &.general {
    .ds-tree {
      height: calc(100% - 28px);
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "ds-manager:general:title": "Менеджер источников данных",
    "ds-manager:general:subtitle": "Список доступных источников данных"
  },
  "en": {
    "ds-manager:general:title": "Data source manager",
    "ds-manager:general:subtitle": "Available data source list"
  }
}
</i18n>
